import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { COMMON_KEYS, NS } from '../../../i18n/constants/keys';

interface INavBarWelcomeProps {
  userName: string;
  formattedDate: string;
}

export const NavBarWelcome = ({ userName, formattedDate }: INavBarWelcomeProps) => {
  const { t } = useTranslation(NS.common);

  return (
    <Box
      sx={{
        display: { xs: 'none', lg: 'flex' },
        flexDirection: 'column',
        flexShrink: 0,
        mr: 1.5,
        textAlign: 'right',
      }}
    >
      <Typography
        variant='subtitle2'
        sx={{
          fontSize: '0.875rem',
          fontWeight: 600,
          color: 'var(--navbar-text, #ffffff)',
          lineHeight: 1.25,
          letterSpacing: '-0.01em',
        }}
      >
        {t(COMMON_KEYS.navbar.welcome, {
          name: userName,
        })}
      </Typography>
      <Typography
        variant='caption'
        sx={{
          fontSize: '0.72rem',
          fontWeight: 500,
          color: 'var(--navbar-text-muted, rgba(255, 255, 255, 0.75))',
          lineHeight: 1.2,
          mt: 0.25,
        }}
      >
        {formattedDate}
      </Typography>
    </Box>
  );
};
